import {
  EnumFilterEditor,
  EnumFilterViewer,
  SearchUtils,
  createFilter,
} from '@spotify/confidence-core-react';

import { LabelDefinition } from '../../hooks/useLabelsForResource';

export const createLabelFilter = (labelDefinition: LabelDefinition) => {
  const escapedLabelId = SearchUtils.escapeQuery(labelDefinition.id);

  return createFilter<string[]>({
    id: `label-${labelDefinition.id}`,
    label: labelDefinition.displayName,
    category: 'Labels',
    query: (values: string[]) => {
      if (values.length === 0) return '';
      return values
        .map(v => `labels.${escapedLabelId}:"${SearchUtils.escapeQuery(v)}"`)
        .join(' OR ');
    },
    viewer: props => (
      <EnumFilterViewer
        options={labelDefinition.allowedValues}
        pluralLabel={`${labelDefinition.displayName} values`}
        {...props}
      />
    ),
    editor: props => (
      <EnumFilterEditor options={labelDefinition.allowedValues} {...props} />
    ),
  });
};

export const createLabelFilters = (labelDefinitions: LabelDefinition[]) => {
  return labelDefinitions.map(def => createLabelFilter(def));
};
